import { apiDelete, apiGet, apiPatch } from '../../services/apiClient';
import { getLocalItem, getSessionItem } from '../../utils/safeStorage';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const ADMIN_ACCESS_KEY = 'adminAccessToken';

const parseMessage = async (res) => {
  const text = await res.text();
  if (!text) return res.ok ? '' : 'Request failed';
  try {
    const parsed = JSON.parse(text);
    return parsed?.message || text;
  } catch (_) {
    return text;
  }
};

const refreshAdminToken = async () => null;

const resolveAdminToken = async (token) => {
  if (token) return token;
  const stored = getSessionItem(ADMIN_ACCESS_KEY) || getLocalItem(ADMIN_ACCESS_KEY) || null;
  if (stored) return stored;
  return refreshAdminToken();
};

const requestMultipart = async (method, path, formData, token) => {
  const effectiveToken = await resolveAdminToken(token);
  const doFetch = (authToken) =>
    fetch(`${API_BASE}${path}`, {
      method,
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
      credentials: 'include',
      body: formData,
    });

  let res = await doFetch(effectiveToken);
  if (res.status === 401) {
    const refreshed = await refreshAdminToken();
    if (refreshed) res = await doFetch(refreshed);
  }

  if (!res.ok) {
    const message = await parseMessage(res);
    const err = new Error(message || 'Request failed');
    err.status = res.status;
    throw err;
  }

  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const listHomeSectionBanners = async ({ section_key, banner_type } = {}, token) => {
  const params = new URLSearchParams();
  if (section_key) params.set('section_key', section_key);
  if (banner_type) params.set('banner_type', banner_type);
  const qs = params.toString();
  const res = await apiGet(`/api/admin/banners${qs ? `?${qs}` : ''}`, token);
  return res?.data || res?.items || res || [];
};

export const createHomeSectionBanner = async (payload, file, token) => {
  const form = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    form.append(key, String(value));
  });
  if (file) form.append('image', file);
  return requestMultipart('POST', '/api/admin/banners', form, token);
};

export const updateHomeSectionBanner = async (id, payload, file, token) => {
  const form = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    form.append(key, String(value));
  });
  if (file) form.append('image', file);
  return requestMultipart('PUT', `/api/admin/banners/${id}`, form, token);
};

export const toggleHomeSectionBanner = async (id, is_active, token) =>
  apiPatch(`/api/admin/banners/${id}/toggle`, { is_active }, token);

export const deleteHomeSectionBanner = async (id, token) => apiDelete(`/api/admin/banners/${id}`, token);


